import { ComponentStyleConfig } from '@chakra-ui/react';

export const Menu: ComponentStyleConfig = {
   parts: ['button', 'list', 'item', 'groupTitle', 'command', 'divider'],
   baseStyle: {
      list: {
         boxShadow: 'lg',
      },
   },
};
